import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
import { getFullUrl } from 'hubspot-url-utils';
import { ReplyRecUnsuccessfulReason } from './ReplyRecUnsuccessfulReason';
import { jsx as _jsx } from "react/jsx-runtime";
export const LegacyDisabledTooltipMessage = ({
  hasReplyRecsEnabled,
  unsuccessfulReason
}) => {
  const replyRecsSettingsUrl = `${getFullUrl('app')}/helpdesk-settings/${PortalIdParser.get()}/inboxes/reply-recommendations`;
  if (hasReplyRecsEnabled) {
    return /*#__PURE__*/_jsx(ReplyRecUnsuccessfulReason, {
      unsuccessfulReason: unsuccessfulReason
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'hubspot-prosemirror.replyRecommendations.generationMessages.inactive_jsx',
    elements: {
      Link
    },
    options: {
      href: replyRecsSettingsUrl,
      external: true,
      onClick: e => {
        e.stopPropagation();
      }
    }
  });
};